import { render, staticRenderFns } from "./BeaconsPage.vue?vue&type=template&id=0fa5e740&"
import script from "./BeaconsPage.vue?vue&type=script&lang=js&"
export * from "./BeaconsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports